export default __webpack_public_path__ + "static/media/foldericon.1ee90e71.svg";